import { apiCallAdmin, apiCallGeneric } from "../../../services/api-service.js";
const dockUrl = process.env.REACT_APP_DOCK_API_URL;
const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;

export const getLocationApi = async (term) => {
    return await apiCallAdmin("GET", `get_location?term=${term}`);
};
export const getDeptApi = async (term) => {
    return await apiCallAdmin("GET", `get_department?term=${term}`);
};




export const getCustomerListApi = async (params) => {
    console.log("dockUrl", dockUrl);
    console.log("dockUrl", process.env.REACT_APP_DOCK_API_URL);
    return await apiCallGeneric("GET", `${dockUrl}customer?${params}`);
};
export const saveCustomerApi = async (body) => {
    return await apiCallGeneric("POST", `${dockUrl}customer`, body);
};
export const updateCustomerApi = async (body, id) => {
    return await apiCallGeneric("PUT", `${dockUrl}customer/${id}`, body);
};
export const getCustomerApi = async (id) => {
    return await apiCallGeneric("GET", `${dockUrl}customer/${id}`);
};

export const getTransporterListApi = async (params) => {
    return await apiCallGeneric("GET", `${dockUrl}transporter?${params}`);
};
export const saveTransporterApi = async (body) => {
    return await apiCallGeneric("POST", `${dockUrl}transporter`, body);
};
export const updateTransporterApi = async (body, id) => {
    return await apiCallGeneric("PUT", `${dockUrl}transporter/${id}`, body);
};
export const getTransporterApi = async (id) => {
    return await apiCallGeneric("GET", `${dockUrl}transporter/${id}`);
};



export const getVendorListApi = async (params) => {
    return await apiCallGeneric("GET", `${dockUrl}vendor?${params}`);
};
export const saveVendorApi = async (body) => {
    return await apiCallGeneric("POST", `${dockUrl}vendor`, body);
};
export const updateVendorApi = async (body, id) => {
    return await apiCallGeneric("PUT", `${dockUrl}vendor/${id}`, body);
};
export const getVendorApi = async (id) => {
    return await apiCallGeneric("GET", `${dockUrl}vendor/${id}`);
};




export const getDeleteCustomerApi = async (id) => {
    return await apiCallGeneric("DELETE", `${dockUrl}customer/${id}`);
};
export const getDeleteTransporterApi = async (id) => {
    return await apiCallGeneric("DELETE", `${dockUrl}transporter/${id}`);
};
export const getDeleteVendorApi = async (id) => {
    return await apiCallGeneric("DELETE", `${dockUrl}vendor/${id}`);
};